import { FIREBASE_ERROR_CODES } from '../../../firebase/interfaces';
import { LOGOUT } from 'utilities/routes';
import { useState } from 'react';
import { useGetPage } from 'hooks/useGetPage';
import { pageIds } from 'utilities/constants';
import { useNavigate } from 'react-router-dom';

export const useHandleFirebaseError = () => {
  const { data: locale } = useGetPage({
    locale: 'en',
    pageId: pageIds.MY_PROFILE,
  });

  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const errorHandlers: Record<string, () => Promise<void> | void | string> = {
    [FIREBASE_ERROR_CODES.AUTH_REQUIRES_RECENT_LOGIN]: async () => {
      navigate(LOGOUT);
    },
    [FIREBASE_ERROR_CODES.AUTH_INVALID_PHONE_NUMBER]: () => {
      setError(locale.securityAndPrivacy.phoneError);
      return locale.securityAndPrivacy.phoneError;
    },
    [FIREBASE_ERROR_CODES.AUTH_SECOND_FACTOR_ALREADY_IN_USE]: () => {
      setError(locale.securityAndPrivacy.phoneNumberAlreadyInUse);
      return locale.securityAndPrivacy.phoneError;
    },
    [FIREBASE_ERROR_CODES.AUTH_TOO_MANY_REQUESTS]: () => {
      setError(locale.securityAndPrivacy.tooManyRequests);
      return locale.securityAndPrivacy.phoneError;
    },
  };

  const handleFirebaseError = async (errorCode: string) => {
    if (errorCode) {
      const handler = errorHandlers[errorCode];
      if (handler) {
        const err = await handler();
        return err;
      } else {
        setError(locale.securityAndPrivacy.unexpectedError);
        return locale.securityAndPrivacy.unexpectedError;
      }
    }
  };

  return { handleFirebaseError, error, setError };
};
